import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { Message } from './chat.types'

interface ChatState {
  messages: Message[]
  isTyping: boolean
  error: string | null
}

const initialState: ChatState = {
  messages: [],
  isTyping: false,
  error: null,
}

const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    addMessage: (state, action: PayloadAction<Message>) => {
      state.messages.push(action.payload)
    },
    setTyping: (state, action: PayloadAction<boolean>) => {
      state.isTyping = action.payload
    },
    clearMessages: (state) => {
      state.messages = []
    },
  },
})

export const { addMessage, setTyping, clearMessages } = chatSlice.actions
export default chatSlice.reducer
